import { graphql } from 'gql';

export const copyProjectGql = graphql(`
    mutation copyProject($uniqueId: String!) {
        copyProject(uniqueId: $uniqueId) {
            data {
                uniqueId
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);
